import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import localePt from '@angular/common/locales/pt';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ModalShellComponent } from '@infrastructure/ui/components/modals/modal-shell/modal-shell.component';
import { ConfirmacaoSimNaoComponent } from '@infrastructure/ui/components/modals/confirmacao-sim-nao/confirmacao-sim-nao.component';
import { PeriodoSelectComponent } from '@infrastructure/ui/components/forms/periodo-select/periodo-select.component';
import { DatepickerComponent } from '@infrastructure/ui/components/forms/datepicker/datepicker.component';
import { PrototypeSelectComponent } from '@infrastructure/ui/components/forms/prototype-select/prototype-select.component';
import { SearchMultiselectComponent } from '@infrastructure/ui/components/forms/search-multiselect/search-multiselect.component';
import { PageTitleModule } from '@infrastructure/ui/components/page-title/page-title.module';
import { TabsComponent } from '@infrastructure/ui/components/tabs/tabs.component';
import { TabPanelComponent } from '@infrastructure/ui/components/tabs/tab-panel.component';
import { AnexosComponent } from '@infrastructure/ui/components/anexos/anexos.component';
import { FormFooterComponent } from '@infrastructure/ui/components/forms/form-footer/form-footer.component';
import { UtilsComponentesModule } from '../../../utils/componentes/utils-componentes.module';
import { LucideAngularModule } from 'lucide-angular';
import {
  AlertTriangle,
  ArrowDown,
  ArrowDownAZ,
  ArrowDownZA,
  ArrowUpDown,
  ArrowUp,
  BookOpen,
  Calendar,
  CalendarDays,
  Check,
  ChevronDown,
  Download,
  Edit2,
  Filter,
  FileText,
  Globe,
  Image,
  NotebookPen,
  Paperclip,
  Plus,
  Search,
  Trash2,
  X
} from 'lucide-angular';

import { AcompanhamentoPedagogicoComponent } from './acompanhamento-pedagogico.component';
import { AcompanhamentoFormComponent } from './acompanhamento-form.component';
import { AcompanhamentoListComponent } from './acompanhamento-list.component';
import { AcompanhamentoOrdenacaoDropdownComponent } from './acompanhamento-ordenacao-dropdown.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AcompanhamentoPedagogicoComponent,
    AcompanhamentoFormComponent,
    AcompanhamentoListComponent,
    AcompanhamentoOrdenacaoDropdownComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ModalShellComponent,
    ConfirmacaoSimNaoComponent,
    PeriodoSelectComponent,
    DatepickerComponent,
    PrototypeSelectComponent,
    SearchMultiselectComponent,
    PageTitleModule,
    TabsComponent,
    TabPanelComponent,
    AnexosComponent,
    FormFooterComponent,
    UtilsComponentesModule,
    LucideAngularModule.pick({
      AlertTriangle,
      ArrowDown,
      ArrowDownAZ,
      ArrowDownZA,
      ArrowUpDown,
      ArrowUp,
      BookOpen,
      Calendar,
      CalendarDays,
      Check,
      ChevronDown,
      Download,
      Edit2,
      Filter,
      FileText,
      Globe,
      Image,
      NotebookPen,
      Paperclip,
      Plus,
      Search,
      Trash2,
      X
    })
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }],
  exports: [AcompanhamentoPedagogicoComponent]
})
export class AcompanhamentoPedagogicoModule { }
